export const state = {
  categories: null,
  rewards: null,
  reward: null,
};
